type PosthogPersonProps = Record<string, unknown>

declare global {
    interface Window {
        posthog?: {
            init: (key: string, options: Record<string, unknown>) => void
            identify: (distinctId?: string, properties?: PosthogPersonProps) => void
            capture: (event: string, properties?: Record<string, unknown>) => void
            reloadFeatureFlags?: () => void
            __loaded?: boolean
        }
    }
}

export const capture = (event: string, properties?: Record<string, unknown>): void => {
    try {
        window.posthog?.capture(event, properties)
    } catch (error) {
        console.error(error)
    }
}

export const capturePageview = (): void => {
    capture('$pageview')
}

export interface IdentifyInput {
    uuid?: string
    country?: string
    subscriptions?: {
        status?: string
        plan?: string
        device?: string
    }[]
}

export const identify = (data: IdentifyInput): void => {
    try {
        if (!data?.uuid) return
        window.posthog?.identify(data.uuid, {
            country: data.country,
            subscriptions: data.subscriptions || [],
        })
    } catch (error) {
        console.error(error)
    }
}
